import { SET_MODIFIERS, SET_MODIFIERS_SELECTED, SET_PRODUCT, SET_PRODUCT_SELECTED } from '../types';

const initialState = {
  modifiers: [],
  modifiers_selected: [],
  product: [],
  product_selected: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_MODIFIERS:
      return {
        ...state,
        modifiers: action.payload,
      };
    case SET_MODIFIERS_SELECTED:
      return {
        ...state,
        modifiers_selected: action.payload,
      };
    case SET_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case SET_PRODUCT_SELECTED:
      return {
        ...state,
        product_selected: action.payload,
      };
    default:
      return state;
  }
}
